import { ApiClientImplementation } from 'infra/api-client/api-client'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { PrepareApiRequestPatientDocumentDecorator } from 'main/decorators/prepare-api-request-patient-document-decorator/prepare-api-request-patient-document-decorator'
import { PatientDocumentRepository } from 'repository/repositories/patient-document/patient-document-repository'
import PatientDocumentService from 'presentation/contexts/services/patient-document-service'
import { RemoteGetPatientDocuments } from 'service/usecases/get-patient-documents/remote-get-patient-documents'

export default function makePatientDocumentService() {
  const apiPatientDocumentRepository =
    new PrepareApiRequestPatientDocumentDecorator(
      makeLocalStorageAdapter(),
      new ApiRepository(new ApiClientImplementation())
    )
  const patientDocumentRepository = new PatientDocumentRepository(
    apiPatientDocumentRepository
  )

  const getPatientDocuments = new RemoteGetPatientDocuments(
    patientDocumentRepository
  )

  return new PatientDocumentService({
    getPatientDocuments
  })
}
